import React from 'react'
import PropTypes from 'prop-types'
import { EditTriggerForm } from 'local/components'

const TriggerAddComponent = ({ onSubmit }) => (
  <EditTriggerForm header="Add Trigger" onSubmit={onSubmit} />
)

TriggerAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default TriggerAddComponent
